 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHTNOTICE from '@/components/xhtml/copyrightnotice'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLFOREWORD from '@/components/xhtml/foreword'
 import XHTMLPART1 from '@/components/xhtml/part1'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLEPILOGUE from '@/components/xhtml/epilogue'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLADCARD from '@/components/xhtml/adcard'
 import XHTMLABOUTTHEAUTHOR from '@/components/xhtml/abouttheauthor'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/dedication",
 			"name" : "xhtml/dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/foreword",
 			"name" : "xhtml/foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/part1",
 			"name" : "xhtml/part1",
 			"component" : XHTMLPART1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js